export default __webpack_public_path__ + "static/media/fitness-prev-icon.0785d59b.svg";